import { render, staticRenderFns } from "./children-en.vue?vue&type=template&id=46e0e140&lang=pug&"
import script from "./children-en.vue?vue&type=script&lang=js&"
export * from "./children-en.vue?vue&type=script&lang=js&"
import style0 from "./children-en.vue?vue&type=style&index=0&id=46e0e140&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports